export default __webpack_public_path__ + "static/media/logo.242fe640.jpg";